import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "relative",
  ref: "menuRef"
}
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "absolute left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50"
}
const _hoisted_5 = { class: "flex items-center justify-center w-10 h-10 rounded-lg bg-violet-100" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex-1 text-left" }
const _hoisted_8 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-violet-600"
}
const _hoisted_9 = { class: "flex items-center justify-center w-10 h-10 rounded-lg bg-blue-100" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "flex-1 text-left" }
const _hoisted_12 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-violet-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
      class: _normalizeClass(["flex items-center justify-center w-9 h-9 rounded-md hover:bg-gray-100 transition-colors duration-200", { 'bg-gray-100': _ctx.isMenuOpen }]),
      "aria-label": "App Switcher",
      "aria-haspopup": "true",
      "aria-expanded": _ctx.isMenuOpen
    }, [
      _createElementVNode("div", {
        innerHTML: _ctx.WAFFLE_MENU_ICON,
        class: "text-gray-500 hover:text-gray-700"
      }, null, 8, _hoisted_3)
    ], 10, _hoisted_2),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-150",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "px-3 py-2" }, [
                _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, " Applications ")
              ], -1)),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToExpertsPrograms && _ctx.navigateToExpertsPrograms(...args))),
                class: _normalizeClass(["w-full px-3 py-2 flex items-center gap-3 hover:bg-gray-50 transition-colors duration-150", { 'bg-violet-50': _ctx.currentApp === 'experts-programs' }])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.EXPERTISE_ICON,
                    class: "text-violet-600"
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-sm font-medium text-gray-900", { 'text-violet-600': _ctx.currentApp === 'experts-programs' }])
                  }, " Experts & Programs ", 2),
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Manage your expert network", -1))
                ]),
                (_ctx.currentApp === 'experts-programs')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToInsights && _ctx.navigateToInsights(...args))),
                class: _normalizeClass(["w-full px-3 py-2 flex items-center gap-3 hover:bg-gray-50 transition-colors duration-150", { 'bg-violet-50': _ctx.currentApp === 'insights' }])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.INSIGHTS_SEARCH_ICON,
                    class: "text-blue-600"
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-sm font-medium text-gray-900 flex items-center gap-2", { 'text-violet-600': _ctx.currentApp === 'insights' }])
                  }, " Expert Insights ", 2),
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-xs text-gray-500" }, " Search call transcripts & trends ", -1))
                ]),
                (_ctx.currentApp === 'insights')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                  : _createCommentVNode("", true)
              ], 2),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "my-2 border-t border-gray-100" }, null, -1)),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "px-3 py-2" }, [
                _createElementVNode("p", { class: "text-xs text-gray-400" }, " Switch between apps to access different features ")
              ], -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}